import { Icon } from '@eventbrite/eds-icon';
import { DocumentFill } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import {
    EventDetail,
    EventDetailContent,
    EventDetailHeading,
    EventDetailIcon,
    ICON_COLOR,
    ICON_SIZE,
} from '../EventDetail/EventDetail';

export type RefundPolicyProps = {
    isEnableRetainFeeActive: boolean;
    isPaidEvent: boolean;
    isRefundRequestAllowed: boolean;
    refundPolicyDescription: string;
    refundPolicyIsNoRefunds: boolean;
};

export const RefundPolicy = ({
    isEnableRetainFeeActive,
    isPaidEvent,
    isRefundRequestAllowed,
    refundPolicyDescription,
    refundPolicyIsNoRefunds,
}: RefundPolicyProps) => {
    if (!isPaidEvent) {
        return null;
    }
    const isNonFeeRefundable =
        isEnableRetainFeeActive && !refundPolicyIsNoRefunds;
    const isRequiredContactOrganizer =
        isEnableRetainFeeActive &&
        !refundPolicyDescription &&
        isRefundRequestAllowed;
    const isNonRefunds =
        isEnableRetainFeeActive &&
        !refundPolicyDescription &&
        !isRefundRequestAllowed;
    const LABEL_ID = 'refund-policy-heading';

    return (
        <EventDetail ariaLabelledBy={LABEL_ID}>
            <EventDetailIcon>
                <Icon
                    type={<DocumentFill />}
                    size={ICON_SIZE}
                    color={ICON_COLOR}
                />
            </EventDetailIcon>
            <EventDetailContent>
                <EventDetailHeading>
                    <h3 id={LABEL_ID}>{gettext('Refund policy')}</h3>
                </EventDetailHeading>
                {refundPolicyDescription && (
                    <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: refundPolicyDescription.toString(),
                        }}
                    />
                )}
                {isRequiredContactOrganizer && (
                    <p>
                        {gettext('Contact the organizer to request a refund.')}
                    </p>
                )}
                {isNonFeeRefundable && !isNonRefunds && (
                    <p>{gettext("Eventbrite's fee is nonrefundable.")}</p>
                )}
                {isNonRefunds && <p>{gettext('No Refunds')}</p>}
            </EventDetailContent>
        </EventDetail>
    );
};
